import ReportDetails from './ReportDetails';

export default ReportDetails;
